<button type="button" (click)="toggleDatePicker($event)" class="date-picker-button">
  <svg-icon icon="calendar" class="calendar-icon"></svg-icon>
  <div id="button-title-id">{{ isCustomDateSelected() ? createDisplayedCustomDates() : getActiveDateName() | translate  }}</div>
  <svg-icon icon="{{ isDatePickerOpened ? 'arrow-up' : 'arrow-down' }}" class="arrow-icon"></svg-icon>
</button>

<div *ngIf="isDatePickerOpened" class="date-select-section bc-panel" tabindex="-1" (clickOutside)="onCancel()">
  <ul class="pre-defined-list">
    <li *ngFor="let date of dates" (click)="setInterval(date)">
      <svg-icon icon="checkmark" class="checkmark-icon" [ngClass]="{ 'selected-date-checkmark': isDateActive(date) }"></svg-icon>
      <span [ngClass]="{'selected-date-name': isDateActive(date) }">{{ date.name | translate }}</span>
    </li>
  </ul>

  <div class="date-selection-calendar-section">
    <div class="calendars">
      <div #startCalendar class="start-calendar" tabindex="0">
        <div class="calendar-header">
          <span class="header-text">{{ 'datePicker.from' | translate }}</span>
          <span class="header-date">{{ formattedStartDate }}</span>
        </div>
        <mat-calendar [startAt]="startDate" [selected]="startDate" (selectedChange)="setNewStartDateValue($event)" [maxDate]="today" [minDate]="minimumDate"></mat-calendar>
      </div>
      <div #endCalendar class="end-calendar" tabindex="1">
        <div class="calendar-header">
          <span class="header-text">{{ 'datePicker.to' | translate }}</span>
          <span class="header-date">{{ formattedEndDate }}</span>
        </div>
        <mat-calendar [startAt]="endDate" [selected]="endDate" (selectedChange)="setNewEndDateValue($event)" [maxDate]="today" [minDate]="minimumDate"></mat-calendar>
      </div>
    </div>

    <div class="buttons">
      <button class="btn btn-light cancel-button" (click)="onCancel()" [disabled]="!isCustomDateSelected()">
        <span>{{ 'datePicker.cancel' | translate }}</span>
      </button>

      <button class="btn btn-dark" (click)="onApply()" [disabled]="!isCustomDateSelected()">
        <span>{{ 'datePicker.apply' | translate }}</span>
      </button>
    </div>
  </div>
</div>
